import { Button } from '../Button'
import { Modal, StackModalProps } from 'almanac-ui/Modal'

export interface Props extends StackModalProps {
  onCancel: () => void
  onConfirm: () => void
  onPressOutside: () => void
}

export const VcmDisabledModalConfirm = ({ onCancel, onConfirm, onPressOutside }: Props) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header title="Are you sure you would like to turn off Version Control Mode?" />
    <Modal.Content>
      <p>
        Disabling Version Control Mode will allow users to make direct changes to docs they have Edit access to without
        the need to use layers.
      </p>
    </Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Button onPress={onCancel} size="xl" variant="tertiary">
          Cancel
        </Button>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Button onPress={onConfirm} size="xl" variant="primary">
          Confirm
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
